import clsx from 'clsx'
import {orderBy} from 'lodash'
import React from 'react'
import {useLocation, useHistory} from 'react-router-dom'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'

import {AssignedContentIcon} from 'resources/icons'

const Container = styled(Box)(linkStyles)

export default function AssessmentLink (props) {

  const {context} = props
  const assessments = orderBy(props.assessments, ['title'])
  const {translate} = context
  const disabled = assessments.length < 1 || props.busy
  const multiAssessment = assessments.length > 1

  const location = useLocation()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const openMenu = (event) =>  setAnchorEl(event.currentTarget)
  const closeMenu = e => {
    setAnchorEl(null)
    e.preventDefault()
  }


  function goToAssessment(assessment) {
    if (props.onSelect) return props.onSelect(assessment)
    const assessmentLink = context.link({assessment, action: 'preview', page: 'quiz'}, '/:languageId/:role/:page/:assessment/:action')
    context.updateState({quizPreviewFrom: {$set: location.pathname}, quizPreviewFromQuery: {$set: {...context.query}}})
    history.push(assessmentLink)
  }

  function handleMenuClick({id}) {
    return e => {
      if (!disabled) goToAssessment(id)
      e.preventDefault()
    }
  }

  function handlePreviewClick (e) {
    if (multiAssessment) {
      if (!disabled)
      openMenu(e)
    } else {
      if (!disabled) goToAssessment(assessments[0].id)
    }
    e.preventDefault()
  }

  const title = multiAssessment || disabled ? '' :`${translate('preview-tooltip')}${multiAssessment ? '' : `: ${assessments[0].title}`}`
  return (<Tooltip title={title}>
    <Container className={clsx("assessment", {disabled})}>
         <div onClick={handlePreviewClick} className={clsx("assessmentButton", {disabled})}>
           <AssignedContentIcon />
         </div>
         {multiAssessment && (<Menu
            anchorEl={anchorEl}
            open={open}
            onClose={closeMenu}
          >
           {assessments.map(assessment => (<MenuItem key={assessment.id} onClick={handleMenuClick(assessment)}>{assessment.title}</MenuItem>))}
          </Menu>)}
    </Container>
  </Tooltip>)
}

function linkStyles ({theme}) {
  return {
    "&.assessment": {
      marginRight: 0,
      marginLeft: 26,
      "& .assessmentButton": {
        cursor: 'pointer',
        "&:hover": {
          "& svg": {
            transform: 'scale(1.15)'
          }
        },
        "&.disabled": {
          cursor: 'default',
          visibility: 'hidden',
          opacity: 0.5,
          "&:hover": {
            "& svg": {
              transform: 'none'
          }
        },
        },
    }
  }
  }
}
